// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-mediumOnConfined-button-0c69cd7f","buttonLoading":"skins-mediumOnConfined-buttonLoading-a528f85d"};